<template>
    <v-dialog v-model="shows" width="960" persistent :fullscreen="$vuetify.breakpoint.mobile">
        <template #activator="{attrs, on}">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card outlined class="fill-height" v-bind="{ loading }">
            <v-card-title> 자재벤더 키워드 검색 <v-spacer /> <v-icon @click="shows = false">mdi-close</v-icon> </v-card-title>
            <v-divider />
            <v-data-table v-bind="{ headers, items, loading }">
                <template #top>
                    <v-card-text>
                        <v-text-field v-model="keyword" label="키워드" clearable rounded v-bind="{ ...attrs_input, loading }" append-icon="mdi-magnify" @keydown.enter="search" @click:append="search" />
                    </v-card-text>
                    <v-divider />
                </template>
                <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :title="header.withTitle ? header.formatter.bind(item)(value, item) : undefined" v-html="header.formatter.bind(item)(value, item)" /> </template>
                <template #[`item.code`]="{ item }">
                    <v-list-item dense target="_blank" :href="item.href">
                        <v-list-item-avatar color="content">
                            <v-img :src="item.photo">
                                <template #placeholder> <v-icon>mdi-chip</v-icon> </template>
                            </v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title :title="item.code"> {{ item.code }} </v-list-item-title>
                            <v-list-item-subtitle :title="item.vendorItemCode"> {{ item.vendorItemCode }} </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <template #[`item.actions`]="{ item }">
                    <manufacturing-material-link-post-btn v-bind="{ material, loading }" :searchItem="item" small text color="primary" v-on="{ setLoading, updateLinkItem }">
                        연결하기
                    </manufacturing-material-link-post-btn>
                </template>
            </v-data-table>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input, initDataTableHeaders, initManufacturingMaterial, MANUFACTURING_VENDOR_CODES, MANUFACTURING_VENDOR_CURRENCIES } from "@/assets/variables";
import ManufacturingMaterialLinkPostBtn from "../action/manufacturing-material-link-post-btn.vue";

export default {
    components: {
        ManufacturingMaterialLinkPostBtn,
    },
    props: {
        material: { type: Object, default: initManufacturingMaterial },
    },
    data: () => ({
        keyword: null,
        searches: [],

        shows: false,
        loading: false,

        attrs_input,
    }),
    computed: {
        headers() {
            return initDataTableHeaders([
                { text: "벤더", value: "vendorCode", formatter: (value) => MANUFACTURING_VENDOR_CODES[value]?.text, width: +80 },
                { text: "자재", value: "code", cellClass: "text-truncate max-width-0 pa-0", withTitle: true },
                { text: "제조사", value: "maker", cellClass: "text-truncate max-width-0 ", withTitle: true, width: 160 },
                { text: "단위", value: "count", width: +80, formatter: (value) => value?.format?.(), align: "end" },
                {
                    text: "가격",
                    value: "price",
                    width: +80,
                    formatter: (value, item) => {
                        let currency = MANUFACTURING_VENDOR_CURRENCIES[item?.vendor?.currency];
                        console.log(item);
                        let isUSD = currency?.value == MANUFACTURING_VENDOR_CURRENCIES.USD.value;

                        return `${currency?.prefix || ""}${value?.format?.(isUSD ? 2 : 0)}`;
                    },
                    align: "end",
                },
                { text: "재고", value: "stock", width: +80, formatter: (value) => value?.format?.(), align: "end" },
                { text: "", value: "actions", cellClass: "px-0", width: +80, sortable: false },
            ]);
        },
        items() {
            return this.searches.flatMap((item) => item.outcome.map((o) => ({ ...o, _vendor: item?._vendor, _material: item?._material, vendor: item.vendor })));
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        material() {
            this.init();
        },
    },
    methods: {
        init() {
            this.keyword = this.material?.searches__last?.[0]?.keyword || null;
            this.searches = this.material?.searches__last || [];
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { keyword } = this;
                const { _id: _material } = this.material;
                const { searches } = await api.console.manufacturing.materials.keywordSearches.post({ _material, keyword });
                this.searches = searches;
            } finally {
                this.loading = false;
            }
        },
        setLoading(loading) {
            this.loading = loading;
        },
        updateLinkItem(item) {
            this.$emit("updateLinkItem", item);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }
}
</style>
